module.exports = "<p>modules works!</p>\r\n"